/**
 * Product gallery swipe sync — Phase 5.2
 *
 * Pairs with product-gallery-swipe.css scroll-snap layout.
 *
 * Two responsibilities:
 *   1. When thumbnails are clicked, scroll the main media list to
 *      the corresponding item (programmatic scrollIntoView).
 *   2. When the user swipes the main media list, update the
 *      active-thumbnail class to match the centered item.
 *
 * Respects prefers-reduced-motion: scroll behavior set in CSS.
 * Falls through gracefully if elements not present.
 */

(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function init() {
    document.querySelectorAll('media-gallery').forEach(setupGallery);
  }

  function setupGallery(gallery) {
    const mediaList = gallery.querySelector('.product__media-list');
    if (!mediaList) return;

    const items = Array.from(mediaList.querySelectorAll('.product__media-item'));
    if (items.length <= 1) return;

    const thumbsRoot = gallery.querySelector('[id^="GalleryThumbnails"]');
    const thumbs = thumbsRoot
      ? Array.from(thumbsRoot.querySelectorAll('[data-target]'))
      : [];

    // 1. Thumbnail click → scroll main list to corresponding item
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const targetId = thumb.dataset.target;
        if (!targetId) return;
        const targetItem = items.find(function (item) {
          return item.dataset.mediaId === targetId;
        });
        if (targetItem) {
          targetItem.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest',
          });
        }
      });
    });

    // 2. Scroll position → active thumbnail class
    let scrollTimeout;
    function syncActiveThumb() {
      const center = mediaList.scrollLeft + mediaList.clientWidth / 2;
      let closest = null;
      let closestDist = Infinity;
      items.forEach(function (item) {
        const itemCenter = item.offsetLeft + item.offsetWidth / 2;
        const dist = Math.abs(itemCenter - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = item;
        }
      });
      if (!closest) return;

      const activeId = closest.dataset.mediaId;
      // Update is-active on items
      items.forEach(function (i) {
        i.classList.toggle('is-active', i === closest);
      });
      // Update is-active on thumbnails
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.target === activeId);
        const btn = t.querySelector('button');
        if (btn) btn.setAttribute('aria-current', t.dataset.target === activeId ? 'true' : 'false');
      });
    }

    mediaList.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(syncActiveThumb, 80);
    }, { passive: true });

    // Initial sync after layout is settled
    setTimeout(syncActiveThumb, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
